/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * String inflector
 */
export const inflector = {
  /**
   * Converts the first character into upper case
   *
   * @param {string} input The input string to convert
   *
   * @returns {string} The converted output string
   */
  ucfirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
  },

  /**
   * Converts the first character into lower case
   *
   * @param {string} input The input string to convert
   *
   * @returns {string} The converted output string
   */
  lcfirst(input) {
    return input.charAt(0).toLowerCase() + input.substr(1);
  },

  /**
   * Removes whitespace from both ends of a string
   *
   * @param {string} input The input string to convert
   *
   * @returns {string} The converted output string
   */
  trim(input) {
    return input.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  },

  /**
   * Converts 'HelloWorld' to 'hello_world'.
   *
   * @param {string}  input     The input string to convert
   * @param {string=} separator Optional words separator. Default is a single underscore "_"
   *
   * @returns {string} The converted output string
   */
  tableize(input, separator) {
    var output = input
      .replace(/([A-Z\s-]+)/g, '_$1')
      .replace(/^_|[\s-\\/]/g, '')
      .replace(/_+/g, '_')
      .toLowerCase()
    ;

    if (separator && separator !== '_') {
      output = output.replace(/_/g, separator);
    }

    return output;
  },

  /**
   * Converts 'hello_world' to 'HelloWorld'.
   *
   * @param {string} input The input string to convert
   *
   * @returns {string} The converted output string
   */
  classify(input) {
    return this
      .ucfirst(input)
      .replace(/[_\-\s]+(.)/g, function (match, p1) {
        return p1.toUpperCase();
      })
    ;
  },

  /**
   * Converts 'hello_world' or 'HelloWorld' to 'helloWorld'.
   *
   * @param {string} input The input string to convert
   *
   * @returns {string} The converted output string
   */
  camelize(input) {
    return this.lcfirst(this.classify(input));
  },

  /**
   * Converts a cardinal number to an an ordinal number
   *
   *  - A **Cardinal Number** is a number that says how many of something there are,
   *    such as `one`, `two`, `three`, `four`, `five`.
   *  - An **Ordinal Number** is a number that tells the position of something in a list,
   *    such as `1st`, `2nd`, `3rd`, `4th`, `5th` etc.
   *
   * An ordinal number is a type of number that is used to represent the position or rank of an
   * object or a person.
   *
   * @link [Ordinal Numbers](https://byjus.com/maths/ordinal-numbers/)
   *
   * @param {number} number
   *
   * @returns {string} The converted ordinal number
   */
  ordinal(number) {
    var subfix;

    if (number > 3 && number < 21) {
      subfix = 'th';
    } else switch (number % 10) {
      case 1: subfix = 'st'; break;
      case 2: subfix = 'nd'; break;
      case 3: subfix = 'rd'; break;
      default: subfix = 'th'; break;
    }

    return number + subfix;
  },
};
